import React, { useState } from 'react';
import OrganizationsTable from './OrganizationsTable';
import Pagination from './Pagination';
import ReportFilters from './ReportFilters';
import useProductAdminReports, { filterByName, sortRecentFirst } from './useProductAdminReports';
import styles from './ProductAdmin.module.css';
import ui from './ProductAdminDashboard.module.css';
import { SearchIcon, UsersIcon } from './ProductAdminIcons';
import { SectionHeading } from './AdminWidgets';

const PAGE_SIZE = 10;

// Every organization with its plan, document limit and activity, 10 per page
export default function ProductAdminOrganizations() {
  const {
    filters, setFilters, companies, loading, error, load,
  } = useProductAdminReports({ period: 'all' });
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const matching = filterByName(sortRecentFirst(companies), search);
  const lastPage = Math.max(1, Math.ceil(matching.length / PAGE_SIZE));
  const currentPage = Math.min(page, lastPage);
  const pageRows = matching.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

  return (
    <div className={ui.container}>
      <header className={ui.pageHeader}>
        <h1 className={ui.title}>Organizations</h1>
        <p className={ui.subtitle}>All registered organizations, their plans, document limits and signing activity.</p>
      </header>

      <ReportFilters filters={filters} setFilters={setFilters} onApply={load} loading={loading} />

      {error && <div className={styles.error}>{error}</div>}

      <section className={ui.panel}>
        <SectionHeading
          tone="blue"
          icon={<UsersIcon />}
          title="All Organizations"
          text={loading ? 'Loading…' : `${matching.length} of ${companies.length} organization${companies.length === 1 ? '' : 's'}`}
        />
        <div className={ui.searchBox}>
          <SearchIcon size={16} />
          <input
            className={ui.searchInput}
            placeholder="Search organization…"
            value={search}
            onChange={e => { setSearch(e.target.value); setPage(1); }}
            aria-label="Search organization"
          />
        </div>
        {loading ? <p className={styles.loading}>Loading…</p> : (
          <>
            <OrganizationsTable companies={pageRows} searching={Boolean(search.trim())} />
            <Pagination page={currentPage} pageSize={PAGE_SIZE} total={matching.length} onChange={setPage} />
          </>
        )}
      </section>
    </div>
  );
}
